import 'whatwg-fetch'
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import Vuex from 'vuex'
import * as VueGoogleMaps from 'vue2-google-maps'

import App from '@/app.vue'

import router from './router'
import store from './stores/store'

import i18n from '@/helpers/i18n'

import AuthentificationService from '@/services/authentification'
import SnipcartService from '@/services/snipcart'

import CustomVueI18n from '@/plugins/i18n'
import VueConsts from '@/plugins/consts'
import Sluggify from '@/plugins/sluggify'
import FormGroupMutation from '@/plugins/form-group-mutation'

Vue.use(CustomVueI18n, { router })
Vue.use(Sluggify)
Vue.use(VueConsts)
Vue.use(Vuelidate)
Vue.use(Vuex)
Vue.use(FormGroupMutation)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAuHSujHNERkj1VIE8xI_KfOynHwMFg7nU',
    libraries: 'places'
  },
  installComponents: true
})

Vue.config.productionTip = false

AuthentificationService.loadLocalState().then(function() {
  new Vue({
    router,
    store,
    i18n: i18n.instance(),
    render: h => h(App)
  }).$mount('#app')
})

document.addEventListener('snipcart.ready', function() {
  window.Snipcart.events.on('cart.confirmed', cartConfirmResponse => {
    SnipcartService.cartConfirmed(cartConfirmResponse)
  })
})
